import React from "react";

import { useAuth } from "../context/AuthContext";

// Approval notifications
import PayrollApprovalNotification from "../components/payroll/PayrollApprovalNotification";
import FeeBatchApprovalNotification from "../components/fees/FeeBatchApprovalNotification";
import FeeSchedulerApprovalNotification from "../components/fees/FeeSchedulerApprovalNotification";

// Timetable
import OngoingClassesPanel from "../components/timetable/OngoingClassesPanel";

// Home widgets
import QuickStatsWidget from "../components/widget/Quickstatswidget";
import LeaveRequestsWidget from "../components/widget/LeaveRequestsWidget";
import NoticeBoardWidget from "../components/widget/noticeboardwidget";
import TodayClassStatusWidget from "../components/widget/Todayclassstatuswidget";

function getGreeting() {
  const hour = new Date().getHours();

  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  if (hour < 21) return "Good evening";

  return "Hello";
}

const SchoolHome = () => {
  const { user, logout } = useAuth();

  const firstName = user?.name?.split(" ")[0] || "";

  return (
    <div className="min-h-screen">
      <div className="max-w-6xl mx-auto p-6">
        {/* Greeting */}
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-neutral-100">
          {getGreeting()}, {firstName}!
        </h1>

        {/* Quick stats */}
        <div className="mt-4">
          <QuickStatsWidget />
        </div>

        {/* Approval notifications */}
        <div className="mt-6 space-y-4">
          <PayrollApprovalNotification
            isPortal={false}
            enabled={true}
          />

          <FeeBatchApprovalNotification
            enabled={true}
          />

          <FeeSchedulerApprovalNotification
            enabled={true}
          />
        </div>

        {/* Dashboard widgets */}
        <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Leave requests */}
          <LeaveRequestsWidget />

          {/* Notice board */}
          <NoticeBoardWidget />

          {/* Ongoing classes */}
          <OngoingClassesPanel
            isPortal={false}
            autoFetch
          />

          {/* Today's class status */}
          <TodayClassStatusWidget />
        </div>

        {/* Logout */}
        
      </div>
    </div>
  );
};

export default SchoolHome;